import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';

@Component({
  selector: 'app-ad-back-button',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, FeatherModule],
  templateUrl: './ad-back-button.component.html',
  styleUrls: ['./ad-back-button.component.scss']
})
export class AdBackButtonComponent {
  @Input() text?: string;
  /** `button` = bordered control; `link` = chevron + label only (no border). */
  @Input() variant: 'button' | 'link' = 'button';
  @Output() clicked = new EventEmitter<void>();

  constructor(private location: Location) {}

  goBack(): void {
    this.clicked.emit();
    // When a parent binds (clicked)="...", it owns navigation (router, close form, reset UI).
    // Calling Location.back() in addition breaks those flows and double-navigates.
    // Use `observers.length` (stable) instead of `observed` (version-dependent).
    if (this.clicked.observers.length === 0) {
      this.location.back();
    }
  }
}


